import { AppRegistry } from 'react-native';
import App from './screens/App';

const appName = "AdminNino"

AppRegistry.registerComponent(appName, () => App);

AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
